export default __webpack_public_path__ + "static/gunluk-analiz-9a9ec947a13b8dd4b733993051c825f8.png";